import React from 'react';
import { PrivacyCheckbox, PrivacyRow, RequiredMark } from './InputPrivacy.styles';

export default function InputPrivacy(props) {
  return (
    <PrivacyRow $hasError={props.hasError} className={props.hasError ? 'is-invalid' : undefined}>
      <PrivacyCheckbox
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={props.checked}
        onChange={props.onChange}
      />
      <span>
        {props.label}
        {props.required === 1 && <RequiredMark> *</RequiredMark>}
      </span>
    </PrivacyRow>
  );
}
